import genericStore from "../generic_store";
import axios from "axios";
import {config} from "./../../config/constants";
export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "spots",
    object: "spot",
    header: [
      //{ text: "Alias ID", value: "alias_id" },
      { text: "Spot", value: "spot" },
      { text: "Imagen Poster", value: "posters" },
      { text: "Tipo", value: "type_spot_id" },
      { text: "Constancia Domicilio", value: "home_constancy", sortable: false },
      { text: "Cartel Colocado", value: "has_sticker", sortable: false },
      { text: "Verified", value: "verified" },
      { text: "Días disponibles", value: "availabledays" },
      { text: "Reviews", value: "spot_id" },
      //{ text: "Notificaciones", value: "notifications" },
      { text: "Acciones", value: "actions", sortable: false },
    ],
    colors: { 
      without_spots: "primary",
      with_spots: "green",
      with_but_without_verification: "yellow",
      without_verification: "grey",
      verification_rejected: "red",
    }
  },
  mutations: {
    ...genericStore.mutations,
  },
  actions: {
    ...genericStore.actions,
    create_message({ commit, state }, data) {
      let saveData = {};
      saveData['spot_notification'] = data;
      return new Promise((resolve, reject) => {
        commit("request");
        axios
          .post(config.api_url + 'spot_notifications', saveData)
          .then((response) => {
            commit("success");
            resolve(response.data);
          })
          .catch((error) => {
            console.log(error);
            commit("error");
            reject(error.response.data);
          });
      });
    },
  },
  getters: {
    ...genericStore.getters,
  },
};
